export const getRidOfDiacritics = (value: string) =>
  value
    .normalize('NFD')
    .replace(/\p{Diacritic}/gu, '')
    .replace('ł', 'l')
    .replace('Ł', 'L')
    .replace('.', '');
